import React__default from 'react';
import { View, Image, StyleSheet } from 'react-native';
import { A as AppAssets } from './index-3256db5b.esm.js';
import { u as useTheme } from './useTheme-90e8e2c2.esm.js';
import { a as AppIcon, A as AppText } from './index-6b88191c.esm.js';

function AppTopBar(_ref) {
  let {
    background,
    color,
    size,
    name,
    label,
    style,
    onPress,
    containerSize,
    isNotificationDisplayed = true,
    containerRadius,
    isClickable,
    canNavigateBack,
    onRightIconClick,
    topBarTitle
  } = _ref;
  const {
    mode,
    currentTheme,
    setMode
  } = useTheme();
  const _style = styleGenerator(currentTheme);
  return /*#__PURE__*/React__default.createElement(View, {
    style: [_style.container, style, {
      width: containerSize,
      height: containerSize
      // borderRadius: containerRadius || containerSize / 2,
    }]
  }, /*#__PURE__*/React__default.createElement(AppIcon, {
    style: _style.leftComp,
    icon: AppAssets.icons.back_icon,
    color: !canNavigateBack && "transparent",
    size: 30,
    isClickable: canNavigateBack,
    onPress: () => {}
  }), topBarTitle ? /*#__PURE__*/React__default.createElement(AppText, {
    style: _style.title
  }, topBarTitle) : /*#__PURE__*/React__default.createElement(Image, {
    style: _style.logo,
    source: mode === "light" ? AppAssets.logo : AppAssets.darkLogo
  }), /*#__PURE__*/React__default.createElement(AppIcon, {
    style: _style.rightComp,
    icon: AppAssets.icons.notification,
    color: !isNotificationDisplayed && "transparent",
    size: 30,
    isClickable: isNotificationDisplayed,
    onPress: onRightIconClick
  }));
}
const styleGenerator = props => {
  var _props$theme;
  return StyleSheet.create({
    container: {
      width: "100%",
      height: 40,
      borderRadius: 0,
      alignItems: "center",
      justifyContent: "space-between",
      flexDirection: "row",
      marginLeft: 10,
      marginRight: 10
    },
    logo: {
      width: 100,
      height: 40,
      marginTop: 0,
      marginBottom: 0
      // alignSelf: "center",
    },

    rightComp: {
      alignSelf: "flex-end"
    },
    leftComp: {
      // display: "none",
    },
    title: {
      fontSize: props === null || props === void 0 ? void 0 : (_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : _props$theme.large_font_size,
      fontWeight: "bold",
      width: "fit-content",
      textAlign: "center"
    }
  });
};
AppTopBar.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppTopBar",
  "props": {
    "isNotificationDisplayed": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "required": false
    }
  }
};

export { AppTopBar as A };
